import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { YearSelectorComponent } from './year-selector.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule
	],
	exports: [
		YearSelectorComponent
	],
	declarations: [
		YearSelectorComponent
	]
})

export class CustomInputModule
{
}



// WEBPACK FOOTER //
// ./src/app/components/input/custom-input.module.ts